import React, { useState,useEffect  } from 'react';
import FormWizard from "react-form-wizard-component";
import 'react-form-wizard-component/dist/style.css';
import ReactDOM from 'react-dom'
import UserPersonalDetails from "./UserPersonalDetails";
import $ from 'jquery';
import EducationQualification from './EducationQualification';
import WorkExperience from './WorkExperience';
import Header from './Header';
import FinalSubmit from './FinalSubmit';
import { environment } from '../environment/production';
import axios from 'axios';
import Preview from './Preview';
import { useNavigate } from "react-router-dom";

function Dashboard(props) {
  const [apiCall, setApiCall] = useState(0)
  const navigate = useNavigate();
  const [index,setIndex]=useState('')
  const options={
    
    headers:{
        'Authorization':sessionStorage.getItem("access_token")
    }
  }
  const handleComplete=(resp)=>{
    axios.post(environment.apiUrl+"/FinalSubmit/getFinalSubmit",JSON.stringify({user_id:sessionStorage.getItem("user_id")}),{headers:(options.headers)})
    .then((resp)=>{
      if(resp['data']['status']==1){
        axios.post(environment.apiUrl+"/FinalSubmit/sendFinalSubmitMail",JSON.stringify({user_id:sessionStorage.getItem("user_id"),email_id:sessionStorage.getItem("email_id")}),{headers:(options.headers)})
        .then((resp)=>{
          if(resp['data']['status']==1){
            sessionStorage.setItem("reference_id",resp.data.reference_id)
            alert(resp['data']['msg'])
            navigate('/reference-id')
          }
        })
      }else{
        alert(resp['data']['msg'])
      }
    })
  
  
  }
 
  useEffect(() => {
  
    const options={
      
      headers:{
        'Authorization':sessionStorage.getItem("access_token")
      }
    }
    if (apiCall == 0) {
      
      if(sessionStorage.getItem("reference_id")!==null || sessionStorage.getItem("user_id")==null){
        sessionStorage.removeItem("access_token");
        sessionStorage.removeItem("user_id");
        sessionStorage.removeItem("email_id")
        sessionStorage.removeItem("mobile_no")
        sessionStorage.removeItem("first_name")
        sessionStorage.removeItem("middle_name")
        sessionStorage.removeItem("last_name")
        sessionStorage.removeItem("reference_id")
        navigate("/")
      }
      axios.post(environment.apiUrl+"/Personal/getPersonalDetails",JSON.stringify({user_id:parseInt(sessionStorage.getItem('user_id'))}),({headers:(options.headers)}))
      .then((response)=>{
        
        if(response['data']['status']==1){
          
          $('.wizard-btn').attr('disabled',false)
        }else{
          
          $('.wizard-btn').attr('disabled',true)
        }
      })
      
    }
    setApiCall(1)
    }, [apiCall]);
    function enableNextButtonEdu(resp){
      if(resp==1){
        $('.wizard-btn').attr('disabled',false)
      }else{
        
        $('.wizard-btn').attr('disabled',true)
      }
     }
     function enableNextButtonWorkExp(resp){
      if(resp==1){
        $('.wizard-btn').attr('disabled',false)
      }else{
        
        $('.wizard-btn').attr('disabled',true)
      }
     }
     function enableNextButtonFinalSubmit(resp){
      if(resp){
        $('.wizard-btn').attr('disabled',false)
      }else{
        
        $('.wizard-btn').attr('disabled',true)
      }
     }
     
  const tabChanged = ({
    prevIndex,
    nextIndex,
  }: {
    prevIndex: number;
    nextIndex: number;
  }) => {
  if(prevIndex==0){
     //alert("inside first tab")
  }else if(prevIndex==1){
    enableNextButtonEdu()
    }else if(prevIndex==2){
      enableNextButtonWorkExp()
    }else if(prevIndex==3){
      enableNextButtonFinalSubmit()
    }
    
  };

  return (
    <>
    <Header></Header>
      <FormWizard
        shape="circle"
        color="#e74c3c"
        onComplete={handleComplete}
        onTabChange={tabChanged}
      >
        <FormWizard.TabContent title="Personal details" icon="ti-user">
          {/* Add your form inputs and components for the frst step */}
         <UserPersonalDetails ></UserPersonalDetails>
        </FormWizard.TabContent>
        <FormWizard.TabContent title="Education Qualification" icon="fa fa-city">
         <EducationQualification data={enableNextButtonEdu}></EducationQualification>
        </FormWizard.TabContent>
        <FormWizard.TabContent title="Work Experience" icon="ti-briefcase">
         <WorkExperience data={enableNextButtonWorkExp} ></WorkExperience>
        </FormWizard.TabContent>
        <FormWizard.TabContent title="Final Submit" icon="ti-check">
         <FinalSubmit data={enableNextButtonFinalSubmit} ></FinalSubmit>
        </FormWizard.TabContent>
       
      </FormWizard>
      {/* add style */}
      <style>{`
        @import url("https://cdn.jsdelivr.net/gh/lykmapipo/themify-icons@0.1.2/css/themify-icons.css");
        @import url("https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.2.0/css/all.min.css");
      `}</style>
    </>
  );
}

export default Dashboard;
